// Simple profanity filter implementation
const badWords = [
  'ass', 'damn', 'hell', 'shit', 'fuck', 'bitch', 'cunt', 'dick', 'pussy', 'cock',
  // Additional words specific to mental health context
  'kill', 'die', 'suicide', 'hurt', 'harm', 'hate', 'stupid', 'ugly', 'worthless'
];

// Create a regex pattern for all bad words with word boundaries
const pattern = new RegExp('\\b(' + badWords.join('|') + ')\\b', 'gi');

export const filterProfanity = (text) => {
  // Replace bad words with asterisks of the same length
  return text.replace(pattern, match => '*'.repeat(match.length));
};

export const hasProfanity = (text) => {
  // Test if the text contains any bad words
  return pattern.test(text);
};